import { render, staticRenderFns } from "./lezhi_project3.vue?vue&type=template&id=39abf120&"
import script from "./lezhi_project3.vue?vue&type=script&lang=js&"
export * from "./lezhi_project3.vue?vue&type=script&lang=js&"
import style0 from "./lezhi_project3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports